import { FC } from 'react';

interface AlignCenterIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const AlignCenterIcon: FC<AlignCenterIconProps> = ({
  color = 'currentColor',
  size = '16',
  className,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M14.4016 2.53336H1.60156M13.2016 6.00003H3.78547M14.4016 9.4667H1.60156M11.6016 12.5334L4.76018 12.5334"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
